/* POURÉ — global.js (no dependencies) */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var format = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} €';
    var amount = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount)
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString());
  }

  /* ---------- mobile menu ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function renderCart(cart) {
    if (!drawer) return;
    updateCartCount(cart.item_count);

    var itemsEl = drawer.querySelector('[data-cart-items]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var footerEl = drawer.querySelector('[data-cart-footer]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    var shippingEl = drawer.querySelector('[data-shipping-bar]');

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.classList.remove('hidden');
      if (footerEl) footerEl.classList.add('hidden');
      if (shippingEl) shippingEl.classList.add('hidden');
      return;
    }
    if (emptyEl) emptyEl.classList.add('hidden');
    if (footerEl) footerEl.classList.remove('hidden');

    if (shippingEl) {
      shippingEl.classList.remove('hidden');
      var threshold = parseInt(shippingEl.getAttribute('data-threshold'), 10);
      if (threshold > 0) {
        var remaining = threshold - cart.total_price;
        shippingEl.innerHTML = remaining > 0
          ? shippingEl.getAttribute('data-msg-remaining').replace('[amount]', '<strong>' + formatMoney(remaining) + '</strong>')
          : '<strong>' + shippingEl.getAttribute('data-msg-reached') + '</strong>';
      }
    }

    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? item.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_200x$1$2')
        : '';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return '<div class="cart-line" data-line-key="' + item.key + '">' +
        '<div class="cart-line__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="100" height="100">' : '') + '</div>' +
        '<div class="cart-line__info">' +
          '<p class="cart-line__title"><a href="' + item.url + '">' + item.product_title + '</a></p>' +
          (variantTitle ? '<p class="cart-line__variant">' + variantTitle + '</p>' : '') +
          '<div class="cart-line__row">' +
            '<div class="quantity-input">' +
              '<button type="button" data-qty-change="-1" aria-label="Menge verringern">&minus;</button>' +
              '<input type="number" value="' + item.quantity + '" min="0" aria-label="Menge" data-qty-input>' +
              '<button type="button" data-qty-change="1" aria-label="Menge erhöhen">+</button>' +
            '</div>' +
            '<span class="cart-line__price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-line__remove" data-remove-line>Entfernen</button>' +
        '</div>' +
      '</div>';
    }).join('');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]') || e.target.matches('.cart-drawer__overlay')) closeDrawer();

      var line = e.target.closest('.cart-line');
      if (!line) return;
      var key = line.getAttribute('data-line-key');
      var input = line.querySelector('[data-qty-input]');

      if (e.target.closest('[data-qty-change]')) {
        var delta = parseInt(e.target.closest('[data-qty-change]').getAttribute('data-qty-change'), 10);
        var qty = Math.max(0, parseInt(input.value, 10) + delta);
        changeLine(key, qty);
      }
      if (e.target.closest('[data-remove-line]')) changeLine(key, 0);
    });

    drawer.addEventListener('change', function (e) {
      if (e.target.matches('[data-qty-input]')) {
        var line = e.target.closest('.cart-line');
        changeLine(line.getAttribute('data-line-key'), Math.max(0, parseInt(e.target.value, 10) || 0));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (!drawer) return;
      e.preventDefault();
      fetchCart().then(renderCart).then(openDrawer);
    });
  });

  /* ---------- AJAX add to cart ---------- */
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!drawer || !window.fetch) return; // graceful fallback: normal POST to /cart/add
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-adding-text') || label; }

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(fetchCart)
        .then(renderCart)
        .then(openDrawer)
        .catch(function (err) {
          alert((err && err.description) || 'Der Artikel konnte nicht hinzugefügt werden.');
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
        });
    });
  });

  /* ---------- quantity steppers (product page) ---------- */
  document.querySelectorAll('[data-product-qty]').forEach(function (wrap) {
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      var input = wrap.querySelector('input');
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-change'), 10));
      input.value = next;
    });
  });

  /* ---------- product form: variants ---------- */
  document.querySelectorAll('[data-product-form-wrapper]').forEach(function (wrapper) {
    var dataEl = wrapper.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = wrapper.querySelector('input[name="id"]');
    var priceEl = wrapper.querySelector('[data-price]');
    var buyBtn = wrapper.querySelector('[data-add-to-cart]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyVariant = document.querySelector('[data-sticky-variant]');

    function selectedOptions() {
      var opts = [];
      wrapper.querySelectorAll('.variant-fieldset').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateGallery(variant) {
      if (!variant || !variant.featured_media_id) return;
      var thumb = document.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
      if (thumb) thumb.click();
    }

    function normalizeOption(value) {
      return String(value).toLowerCase().replace(/\s+/g, '').replace(/\./g, ',');
    }

    function updateRecommendations(variant) {
      document.querySelectorAll('[data-recommendation]').forEach(function (el) {
        var target = el.getAttribute('data-show-for');
        if (!target) { el.classList.remove('hidden'); return; }
        var match = (variant.options || []).some(function (opt) {
          return normalizeOption(opt) === target;
        });
        el.classList.toggle('hidden', !match);
      });
    }

    function onChange() {
      var variant = findVariant(selectedOptions());
      if (!variant) return;
      idInput.value = variant.id;
      updateRecommendations(variant);

      var stickyPriceHtml = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        stickyPriceHtml = '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
          '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
      }
      if (priceEl) priceEl.innerHTML = variant.price_html || stickyPriceHtml;
      if (stickyPrice) stickyPrice.innerHTML = stickyPriceHtml;
      if (stickyVariant) stickyVariant.textContent = variant.title !== 'Default Title' ? variant.title : '';

      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available
          ? buyBtn.getAttribute('data-text-available')
          : buyBtn.getAttribute('data-text-soldout');
      }

      updateGallery(variant);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    wrapper.querySelectorAll('.variant-fieldset input').forEach(function (input) {
      input.addEventListener('change', onChange);
    });
  });

  /* ---------- product gallery ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = thumb.querySelector('img');
        if (!main || !img) return;
        main.src = img.getAttribute('data-full') || img.src;
        main.srcset = '';
        main.alt = img.alt;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- sticky mobile ATC ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var buyArea = document.querySelector('[data-buy-buttons]');
  if (sticky && buyArea && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    stickyObserver.observe(buyArea);

    var stickyBtn = sticky.querySelector('[data-sticky-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('form[data-ajax-cart][data-main-product-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }
})();
